/* Cartes produits v2 (23/09/2026) — « Récemment vus ».
   1) Sur une fiche produit, mémorise le produit affiché (attribut
      data-recently-viewed-set posé par main-product.liquid) dans localStorage,
      clé « lumin-recently-viewed » (même clé et même forme d'entrée que le tiroir
      Lumin, désactivé) : {url, handle, added_at}, 12 entrées max.
   2) <bn-recently-viewed> : lit la liste (hors produit affiché), reste masqué
      sous 2 produits, sinon charge chaque carte à l'approche du viewport via
      /products/<handle>?section_id=bn-card et l'insère dans la grille. */
(function () {
  var KEY = 'lumin-recently-viewed';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function handleOf(url) { var m = /\/products\/([^/?#]+)/.exec(url || ''); return m ? m[1] : null; }

  var trig = document.querySelector('[data-recently-viewed-set][data-product-url]');
  if (trig) {
    var url = trig.dataset.productUrl.split('?')[0];
    var handle = handleOf(url);
    if (handle) {
      var list = read().filter(function (e) { return e.handle !== handle; });
      list.push({ url: url, handle: handle, added_at: Date.now() });
      write(list.slice(-12));
    }
  }

  if (customElements.get('bn-recently-viewed')) return;
  customElements.define('bn-recently-viewed', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      var limit = parseInt(this.dataset.limit, 10) || 8;
      var min = parseInt(this.dataset.min, 10) || 2;
      var exclude = this.dataset.exclude || '';
      var items = read().filter(function (e) { return e.handle && e.handle !== exclude; }).reverse().slice(0, limit);
      if (items.length < min) return;
      this.items = items;
      this.min = min;
      this.removeAttribute('hidden');
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); self.load(); }
      }, { rootMargin: '600px 0px' });
      io.observe(this);
    }
    /* Même ratio que les autres cartes de la page (réglage image_ratio) : la
       carte arrive rendue en portrait par bn-card, on recalcule --ratio-percent
       comme card-product.liquid (adapt = ratio de l'image 1, portrait = 0,8, carré = 1). */
    applyRatio(card) {
      var mode = this.dataset.imageRatio;
      if (!mode) return;
      var ratio = 1;
      var img = card.querySelector('.card__media img');
      if (mode === 'portrait') ratio = 0.8;
      else if (mode === 'adapt' && img && +img.getAttribute('width') && +img.getAttribute('height')) ratio = img.getAttribute('width') / img.getAttribute('height');
      var pct = (100 / ratio) + '%';
      card.querySelectorAll('.card, .card__inner').forEach(function (el) { el.style.setProperty('--ratio-percent', pct); });
      var wrap = card.querySelector('.bn-quick-add-wrap');
      if (wrap) wrap.style.setProperty('--bn-ratio', ratio);
    }
    load() {
      var self = this, grid = this.querySelector('ul');
      var base = this.dataset.cardUrl || '/products/';
      Promise.all(this.items.map(function (item) {
        return fetch(base + item.handle + '?section_id=bn-card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.querySelector('.card-wrapper');
          })
          .catch(function () { return null; });
      })).then(function (cards) {
        cards.forEach(function (card) {
          if (!card) return;
          self.applyRatio(card);
          var li = document.createElement('li');
          li.className = 'grid__item';
          li.appendChild(card);
          grid.appendChild(li);
        });
        if (grid.children.length < self.min) self.setAttribute('hidden', '');
      });
    }
  });
})();
